class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindDrawerEvents();
    this.setHeaderCartIconAccessibility();
    this.prepareProductOptionsCart = this.prepareProductOptionsCart.bind(this);
  }

  connectedCallback() {
    document.addEventListener('click', this.prepareProductOptionsCart, true);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.prepareProductOptionsCart, true);
  }

  prepareProductOptionsCart(event) {
    const button = event.target.closest('.afSpoButton[name="add"]');
    const header = window.spoConfig?.selectors?.header;
    if (!button || button.disabled || !header) return;
    header.drawer = '#CartDrawer';
    header.cart_count = '#cart-icon-bubble';
    header.cart_link = '#cart-icon-bubble';
    window.af_cartType = 'drawer';
    this.productOptionsTrigger = button;
  }

  bindDrawerEvents() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay && overlay.dataset.drawerBound !== 'true') {
      overlay.dataset.drawerBound = 'true';
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  updateHeaderCount(itemCount) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    let count = cartLink.querySelector('.wu-cart-count');
    if (itemCount > 0 && !count) {
      count = document.createElement('span');
      count.className = 'wu-cart-count';
      cartLink.appendChild(count);
    }
    if (count) {
      count.textContent = itemCount;
      count.hidden = itemCount < 1;
    }
    cartLink.setAttribute('aria-label', itemCount > 0 ? `Cart, ${itemCount} items` : 'Cart');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      const trigger = !event.isTrusted && this.productOptionsTrigger
        ? this.productOptionsTrigger : cartLink;
      this.productOptionsTrigger = null;
      this.open(trigger);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this.bindDrawerEvents();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (!sectionElement || !sectionHTML) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
    }));

    setTimeout(() => {
      this.bindDrawerEvents();
      this.open();
    }, 20);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html || '', 'text/html');
    const target = parsed.querySelector(selector);
    return target ? target.innerHTML : '';
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
